import vuetify from '@/plugins/vuetify';
import errorDialog from './error-dialog.vue';

let prevPromise = null;
let promisePending = false;
let prevErrorMessage = '';

export default {
  install(Vue) {
    const $error = (message, title) => {
      const showDialog = (resolve, reject) => {
        try {
          promisePending = true;
          let isVisible = true;
          const props = { message, title, isVisible };
          const on = { };
          const comp = new Vue({
            vuetify,
            render: (h) => h(errorDialog, { props, on }),
          });
          on.dismissed = () => {
            isVisible = false;
            resolve();
            window.setTimeout(() => comp.$destroy(), 100);
          };
          comp.$mount();
          document.getElementById('app').appendChild(comp.$el);
        } catch (err) {
          reject(err);
        }
      };

      if (prevPromise !== null && promisePending) {
        if (prevErrorMessage !== message) {
          return prevPromise.then(() => {
            const promise = new Promise(showDialog).finally(() => {
              promisePending = false;
            });
            prevPromise = promise;
            return promise;
          });
        } else {
          return prevPromise;
        }
      }

      const promise = new Promise(showDialog).finally(() => {
        promisePending = false;
      });
      prevPromise = promise;
      prevErrorMessage = message;
      return promise;
    };

    Vue.prototype.$error = $error;
  },
};
